module.exports = __webpack_public_path__ + "img/HRV.e0aaa267.svg";